module.exports = __webpack_public_path__ + "frontend/images/signpost/green@2.jpg?c670cddb04bd9f6e3bf6720f5c2c9b8f";